export class CloneEntityModel {
  public exstingInstanceHashId : string;
  public newInstanceName : string;
  public entity: string;
  public existingEntityHashId: string;
  public existingEntityName: string;
  public parentEntityName: string;
  public newEntityName: string;
  public clonedEntityResultSting: string;
  public totalClonedEntity: string;
  constructor() {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/instance/models/cloneentity.model.ts